<template>
  <div class="Employee">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <h4>Tìm kiếm</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
          <CCol sm="3">
            <CInput
              label="Họ tên nhân viên"
              placeholder="Điền họ tên đầy đủ nhân viên để tìm kiếm"
              v-validate="'required'"
              v-model="valueName"
              class=" pt-1"
              v-on:keyup.enter="searchTK()"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              label="Số điện thoại"
              placeholder="Điền số điện thoại"
              v-validate="'required'"
              v-model="valuePhone"
              class=" pt-1"
              v-on:keyup.enter="searchTK()"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Đơn vị"
              :options="dataDepartment"
              :value.sync="valueDepartment"
              class=" pt-1"
            />
          </CCol>
        </CRow>
        <CRow style="margin-top:10px">
          <CCol sm="3" />
          <CCol sm="6" class="center">
            <vs-button
              warn
              square
              class="custom_btn_search float-left"
              @click="searchTK()"
            >
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
            <vs-button
              square
              class="float-left"
              @click="AddEmployee()"
            >
              <i class="bx bx-plus"></i>&nbsp;Thêm mới</vs-button
            >
          </CCol>
          <CCol sm="3" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="dataTK"
        compactMode
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
          perPage: 20,
        }"
        :line-numbers="true"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :sort-options="{
          enabled: false,
        }"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'" class="row">
            <div v-if="props.row.status == 1" class="center">
              <vs-tooltip color="square">
                <template #tooltip>
                  Chi tiết nhân viên
                </template>
                <vs-button
                  transparent
                  @click="goEmployeeDetal(props.row.id)"
                  circle
                  icon
                >
                  <i class="bx bx-calendar-edit"></i>
                </vs-button>
              </vs-tooltip>
              <vs-tooltip color="success">
                <vs-button
                  transparent
                  @click="displayEmployeeDepartment(props.row.id)"
                  success
                  circle
                  icon
                  ><i class="bx bxs-user-account"></i
                ></vs-button>
                <template #tooltip>
                  Gán đơn vị cho nhân viên
                </template>
              </vs-tooltip>
              <vs-tooltip color="danger">
                <template #tooltip>
                  Nghỉ việc
                </template>
                <vs-button
                  transparent
                  @click="LockAccount(props.row)"
                  danger
                  circle
                  icon
                >
                  <i class="bx bx-check-circle"></i
                ></vs-button>
              </vs-tooltip>
            </div>

            <div v-if="props.row.status != 1" class="center">
              <vs-tooltip color="success">
                <template #tooltip>
                  Mở
                </template>
                <vs-button
                  transparent
                  @click="LockAccount(props.row)"
                  success
                  circle
                  icon
                >
                  <i class="bx bx-check-circle"></i
                ></vs-button>
              </vs-tooltip>
            </div>
          </div>

          <div v-else-if="props.column.field === 'status'" class="row center">
            <CBadge v-if="props.row.status == 1" color="success"
              >Đang làm</CBadge
            >
            <CBadge v-else-if="props.row.status != 1" color="warning"
              >Nghỉ việc</CBadge
            >
          </div>
        </template>
      </vue-good-table>
    </CCard>

    <vs-dialog prevent-close width="550px" v-model="state.dialog.lock">
      <template #header>
        <h4 class="not-margin">
          Xác nhận
        </h4>
      </template>
      Bạn có chắc chắn muốn thực hiện thao tác này không?
      <template #footer>
        <div class="con-footer flex flex-end">
          <vs-button danger transparent @click="SubmitLock()">
            Đồng ý
          </vs-button>
          <vs-button @click="state.dialog.lock = false" dark transparent>
            Hủy
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog
      prevent-close
      class="employee-dialog"
      width="650px"
      v-model="state.dialog.EmployeeDepartment"
    >
      <CCard class="pb-0">
        <CCardHeader class="pt-0 pb-0">
          <h4>Danh sách đơn vị</h4>
        </CCardHeader>
        <CCardBody class="pt-2 pb-0">
          <CRow>
            <CCol sm="12">
              <CSelect
                label="Loại đơn vị"
                :options="list_department_type"
                :value.sync="value_department_type"
              />
            </CCol>
          </CRow>
          <CRow style="height:20px"> </CRow>
          <CRow>
            <CCol sm="12">
              <vue-good-table
                :columns="ed_columns"
                :rows="ed_data_update"
                max-height="450px"
                :fixed-header="true"
                :sort-options="{
                  enabled: false,
                }"
              >
                <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
                  Không có dữ liệu
                </div>
                <template slot="table-row" slot-scope="props">
                  <div
                    v-if="props.column.field === 'action'"
                    class="checkbox-left center"
                  >
                    <div>
                      <vs-checkbox
                        v-model="props.row.check_department"
                        :value="props.row.check_department"
                        @click="checkEmployeeDepartment(props.row.id)"
                      >
                      </vs-checkbox>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter class="pt-1 pb-1 center">
          <vs-button square @click="SubmitAddEmployeeDepartment()">
            <i class="bx bx-send"></i>&nbsp;Lưu lại
          </vs-button>
        </CCardFooter>
      </CCard>
    </vs-dialog>

    <vs-dialog
      prevent-close
      class="employee-dialog"
      width="800px"
      v-model="state.dialog.EmployeeDetail"
    >
      <template #header>
        <h4 class="not-margin">
          Cập nhật thông tin nhân sự
        </h4>
      </template>

      <div class="con-form">
        <CRow class="mb-2">
          <CCol sm="8" class="mb-2">
            <CInput
              label="Tên nhân viên (*)"
              placeholder=""
              v-validate="'required'"
              v-model="edit_name_employee"
            />
          </CCol>
          <CCol sm="4" class="mb-2">
            <CSelect
              label="Giới tính (*)"
              v-validate="'required'"
              :options="dataGender"
              :value.sync="edit_valueGender"
            />
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol sm="8">
            <CSelect
              :value.sync="edit_position_employee"
              label="Chức danh (*)"
              :options="listCate"
            />
            <!-- <CInput
              label="Chức danh"
              placeholder=""
              v-model="edit_position_employee"
            /> -->
          </CCol>
          <CCol sm="4">
            <span class="font-bold">Ngày sinh (*)</span>
            <b-form-datepicker
              id="datepicker"
              v-model="edit_birthday"
              class="mb-2 mt-2"
              locale="vi"
              placeholder="Ngày sinh"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              :hide-header="true"
              label-help=""
              :value-as-date="true"
            ></b-form-datepicker>
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol sm="12" class="mb-2">
            <CSelect
              label="Phòng ban (*)"
              v-validate="'required'"
              :options="dataDepartment"
              :value.sync="edit_department_employee"
            />
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol sm="6" class="mb-2">
            <CInput
              label="Email"
              placeholder=""
              v-model="edit_email_employee"
            />
          </CCol>
          <CCol sm="6" class="mb-2">
            <CInput
              label="Số điện thoại (*)"
              v-validate="'required'"
              placeholder=""
              v-model="edit_phone_employee"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="EditEmployeeSubmit">
            Cập nhật
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog
      prevent-close
      class="employee-dialog"
      width="800px"
      v-model="state.dialog.NewEmployeeDetail"
    >
      <template #header>
        <h4 class="not-margin">
          Thêm mới nhân sự
        </h4>
      </template>

      <div class="con-form">
        <CRow class="mb-2">
          <CCol sm="8" class="mb-2">
            <CInput
              label="Tên nhân viên (*)"
              placeholder=""
              v-validate="'required'"
              v-model="new_name_employee"
            />
          </CCol>
          <CCol sm="4" class="mb-2">
            <CSelect
              label="Giới tính (*)"
              v-validate="'required'"
              :options="dataGender"
              :value.sync="new_valueGender"
            />
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol sm="8">
            <CSelect
              :value.sync="new_position_employee"
              label="Chức danh (*)"
              :options="listCate"
            />
            <!-- <CInput
              label="Chức danh"
              placeholder=""
              v-model="new_position_employee"
            /> -->
          </CCol>
          <CCol sm="4">
            <span class="font-bold">Ngày sinh (*)</span>
            <b-form-datepicker
              id="datepicker"
              v-model="new_birthday"
              class="mb-2 mt-2"
              locale="vi"
              placeholder="Ngày sinh"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              :hide-header="true"
              label-help=""
              :value-as-date="true"
            ></b-form-datepicker>
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol sm="12" class="mb-2">
            <CSelect
              label="Phòng ban (*)"
              v-validate="'required'"
              :options="dataDepartment"
              :value.sync="new_department_employee"
            />
          </CCol>
        </CRow>
        <CRow class="mb-2">
          <CCol sm="6" class="mb-2">
            <CInput label="Email" placeholder="" v-model="new_email_employee" />
          </CCol>
          <CCol sm="6" class="mb-2">
            <CInput
              label="Số điện thoại (*)"
              v-validate="'required'"
              placeholder=""
              v-model="new_phone_employee"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="AddEmployeeSubmit">
            Thêm mới
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const employeesApi = ClientFactory.get("employees");
import moment from "moment";
const dropdownsApi = ClientFactory.get("dropdowns");

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({
    valueDepartment: "0",
    dataDepartment: [],

    list_department_type: {},
    value_department_type: 1,

    valueName: "",
    valuePhone: "",
    activeAddHoliday: false,
    add_day: "",
    add_note: "",

    columns: [
      {
        label: "UserID",
        field: "id",
        hidden: true,
      },

      {
        label: "Họ tên",
        field: "full_name",
      },
      {
        label: "Số điện thoại",
        field: "phone_number",
      },
      {
        label: "Chức danh",
        field: "position",
      },
      {
        label: "Phòng ban",
        field: "department_name",
      },
      {
        label: "Trạng thái",
        field: "status",
      },
      {
        label: "Thao tác",
        field: "action",
        sortable: false,
        width: "150px",
      },
    ],
    rows: [
      {
        session: "<button>My Action</button>",
        // ...
      },
    ],

    dataTK: [],

    state: {
      dialog: {
        role: false,
        EmployeeDepartment: false,
        reset: false,
        lock: false,
        EmployeeDetail: false,
        NewEmployeeDetail: false,
      },
    },
    ed_columns: [
      {
        label: "Tên đơn vị",
        field: "name",
        thClass: "emu-vgt-thead-th text-center",
        tdClass: "emu-vgt-tbody-td",
      },
      {
        label: "Chọn",
        field: "action",
        thClass: "emu-vgt-thead-th text-center",
        tdClass: "emu-vgt-tbody-td",
        width: "70px",
      },
    ],

    employee_id: 0,
    lock_employee: 0,

    ed_data: [],
    ed_data_update: [],

    role_data: [],
    role_data_update: [],

    dataGender: [
      {
        label: "Nam",
        value: 1,
      },
      {
        label: "Nữ",
        value: 0,
      },
    ],

    listCate: [],

    edit_phone_employee: "",
    edit_email_employee: "",
    edit_department_employee: "",
    edit_birthday: new Date(),
    edit_position_employee: "6",
    edit_valueGender: 1,
    edit_name_employee: "",

    new_phone_employee: "",
    new_email_employee: "",
    new_department_employee: "",
    new_birthday: new Date(),
    new_position_employee: "6",
    new_valueGender: 1,
    new_name_employee: "",
  }),
  async created() {
    this.dataDepartment = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);
    this.searchTK();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    searchTK: async function() {
      this.loading(this.$vs);
      const params = {
        full_name: this.valueName,
        phone_number: this.valuePhone,
        department_id: this.valueDepartment,
      };
      console.log(params);
      const result = await employeesApi.get_employees(params);

      this.checkResponseData(result);
    },

    async LockAccount(params) {
      this.employee_id = params.id;
      this.lock_employee = params.status === 1 ? 1 : 0;
      this.state.dialog.lock = true;
    },

    async SubmitLock() {
      this.loading(this.$vs);
      let body = {};
      body.employee_id = this.employee_id;
      body.lock = this.lock_employee;
      const result = await employeesApi.change_status_employee(body);

      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.lock = false;
        this.add_note = "";
        return this.notify({
          text: result.data[0].error_message,
        });
      }
      this.closeLoading();
    },

    checkResponseData: function(data) {
      console.log(data);
      if (data.status == "success") {
        this.dataTK = data.data;
      } else {
        this.dataTK = [];
      }
      this.closeLoading();
    },
    //#region Thông tin nhân viên
    async goEmployeeDetal(id) {
      this.employee_id = id;
      this.listCate = await dropdownsApi.getItemsTree("TYPE_TITLE");
      this.loadEmployeeDetal(this.employee_id);
    },
    async loadEmployeeDetal(employee_id) {
      this.loading(this.$vs);
      let params = {};
      params.employee_id = employee_id;
      const result = await employeesApi.get_employees(params);
      if (result.status == "success") {
        console.log(result.data[0].position_id);
        console.log(this.edit_position_employee);
        this.edit_position_employee = `${result.data[0].position_id}`;
        this.edit_phone_employee = result.data[0].phone_number;
        this.edit_email_employee = result.data[0].email;
        this.edit_department_employee = result.data[0].department_id;
        this.edit_birthday = moment(
          result.data[0].birthday,
          "DD/MM/YYYY"
        ).toDate();

        this.edit_valueGender = result.data[0].gender;
        this.edit_name_employee = result.data[0].full_name;
        
        this.closeLoading();
        this.state.dialog.EmployeeDetail = true;
      }
    },

    async EditEmployeeSubmit() {
      this.loading(this.$vs);
      let params = {};
      params.employee_id = this.employee_id;
      params.full_name = this.edit_name_employee;
      params.position = this.edit_position_employee;
      params.birthday = moment(this.edit_birthday).format("DD/MM/YYYY");
      params.gender = this.edit_valueGender;
      params.email = this.edit_email_employee;
      params.phone = this.edit_phone_employee;
      params.department_id = this.edit_department_employee;

      const result = await employeesApi.update_employee(params);
      console.log(result);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.EmployeeDetail = false;
        this.ResetFormEdit();
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    async ResetFormEdit() {
      this.edit_phone_employee = "";
      this.edit_email_employee = "";
      this.edit_department_employee = 0;
      this.edit_birthday = new Date();
      this.edit_position_employee = 6;
      this.edit_valueGender = 1;
      this.edit_name_employee = "";
    },

    //#endregion

    //#region  phan group cho acc

    async GetDepartmentType() {
      let cat_code = "DEPARMENT_TYPE";
      this.list_department_type = await dropdownsApi.getItemsTree(cat_code);
    },
    async displayEmployeeDepartment(id) {
      this.employee_id = id;
      this.GetDepartmentType();
      this.loadEmployeeDepartment();
    },
    async loadEmployeeDepartment() {
      this.loading(this.$vs);
      let params = {};
      params.employee_id = this.employee_id;
      params.department_type = this.value_department_type;
      const { data } = await employeesApi.get_employee_deparment(params);
      console.log(data);
      this.ed_data_update = data;
      this.ed_data = JSON.parse(JSON.stringify(this.ed_data_update));
      this.closeLoading()
      this.state.dialog.EmployeeDepartment = true;
    },

    checkEmployeeDepartment(id) {
      let index = this.ed_data.findIndex((c) => c.id === id);
      if (index > -1) {
        this.ed_data[index].check_department = !this.ed_data[index]
          .check_department;
        return;
      }
    },

    async SubmitAddEmployeeDepartment() {
      this.loading(this.$vs);
      let body = {};
      body.employee_id = this.employee_id;
      body.department_type = this.value_department_type;
      body.list_employee_deparment = "-1";
      for (let i = 0; i < this.ed_data.length; i++) {
        if (this.ed_data[i].check_department == true) {
          body.list_employee_deparment =
            body.list_employee_deparment + "," + this.ed_data[i].id;
        }
      }

      console.log(this.value_department_type);
      console.log(body);
      const result = await employeesApi.update_employee_deparment(body);
      console.log(result);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.EmployeeDepartment = false;
        this.add_note = "";
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },

    //#endregion

    //#region Thêm mới thông tin nhân viên
    async AddEmployee() {
      this.loading(this.$vs);
      
      this.listCate = await dropdownsApi.getItemsTree("TYPE_TITLE");
      this.closeLoading();
      this.state.dialog.NewEmployeeDetail = true;
    },
    async AddEmployeeSubmit() {
      this.loading(this.$vs);
      let params = {};
      params.full_name = this.new_name_employee;
      params.position = this.new_position_employee;
      params.birthday = moment(this.new_birthday).format("DD/MM/YYYY");
      params.gender = this.new_valueGender;
      params.email = this.new_email_employee;
      params.phone = this.new_phone_employee;
      params.department_id = this.new_department_employee;

      const result = await employeesApi.create_employee(params);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.state.dialog.NewEmployeeDetail = false;
        this.ResetFormAdd();
        return this.notify({
          text: result.data[0].error_message,
        });
      }
    },
    async ResetFormAdd() {
      this.new_phone_employee = "";
      this.new_email_employee = "";
      this.new_department_employee = 0;
      this.new_birthday = new Date();
      this.new_position_employee = "";
      this.new_valueGender = 1;
      this.new_name_employee = "";
    },

    //#endregion
    showloading: function() {
      this.loading();
      setTimeout(() => {
        this.closeLoading();
      }, 2000);
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
};
</script>

<style lang="scss">
.Employee {
  .vgt-responsive {
      overflow-x: inherit;
  }
  table.vgt-table td {
    vertical-align: inherit;
    padding: 0em 0.75em 0em 0.75em;
  }
  .tk-width-class {
    min-width: 10px !important;
    text-align: center;
  }
  .tk-name-class {
    min-width: none;
    -width: 250px !important;
  }

  .tk-month-class {
    min-width: none;
    -width: 80px !important;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }
  .tk-status-class {
    min-width: 100px;
    text-align: center;
  }
  .tk-action-class {
    min-width: 150px;
    text-align: center;
  }
}
</style>
